import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import type { Language } from '../i18n/translations';
import styles from './LanguageSelector.module.css';

const LANGUAGE_OPTIONS: { code: Language; label: string; flagSrc: string; langAttr: string }[] = [
  { code: 'ko', label: '한국어', flagSrc: '/flags/kr.png', langAttr: 'ko' },
  { code: 'en', label: 'English', flagSrc: '/flags/us.png', langAttr: 'en' },
  { code: 'ja', label: '日本語', flagSrc: '/flags/jp.png', langAttr: 'ja' },
  { code: 'zh', label: '中文', flagSrc: '/flags/cn.png', langAttr: 'zh-Hans' },
];

export function LanguageSelector() {
  const { language, setLanguage } = useLanguage();

  return (
    <div className={styles.container}>
      {LANGUAGE_OPTIONS.map((opt) => (
        <button
          key={opt.code}
          type="button"
          className={`${styles.langButton} ${language === opt.code ? styles.active : ''}`}
          onClick={() => setLanguage(opt.code)}
        >
          <div className={styles.flagWrap}>
            <img
              src={opt.flagSrc}
              alt={opt.label}
              className={styles.flagImg}
            />
          </div>
          <span className={styles.label} lang={opt.langAttr}>{opt.label}</span>
        </button>
      ))}
    </div>
  );
}
